import { render, staticRenderFns } from "./EditarProgramacionInformesModal.vue?vue&type=template&id=64070694&"
import script from "./EditarProgramacionInformesModal.vue?vue&type=script&lang=ts&"
export * from "./EditarProgramacionInformesModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports